var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2568 39.8665L43.0686 52.5872L58.0238 34.9928L52.8246 27.9551H46.3235H42.7959L36.0308 31.474L32.2568 39.8665Z",
    fill: "#3B97D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4293 13H31.6321H22.8349H14.0377L7 22.6769L27.2335 45.5496L32.2567 39.8666L36.1187 35.5032L36.5761 34.993L42.7957 27.9552L47.467 22.6769L40.4293 13Z",
    fill: "#FB7B76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8349 13L17.5566 22.6769H7L14.0377 13H22.8349Z",
    fill: "#FF5364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4673 22.6769H36.9106L31.6323 13H40.4295L47.4673 22.6769Z",
    fill: "#FF5364"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9099 22.6768L27.233 45.5494L21.6468 32.3537L19.7906 27.9551L17.5562 22.6768H36.9099Z",
    fill: "#DF4D60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2206 34.9928H36.5762L42.7958 27.9551H46.3234L50.2206 34.9928Z",
    fill: "#84B5CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0235 34.9928H50.2204L46.3232 27.9551H52.8244L58.0235 34.9928Z",
    fill: "#2980BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2205 34.9932L43.0684 52.5875L36.1187 35.5034L36.5761 34.9932H50.2205Z",
    fill: "#2980BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.5945f81b00c001ea647c44a653a1bb2f.svg";
export { ForwardRef as ReactComponent };